import React, { useState, useEffect } from 'react';
import PageTitle from "../../components/title/pageTitle";
import Navigation from "../../components/navigation/navigation";
import Footer from "../../components/footer/footer";
import PhotoCard from "../../components/PhotoCard/PhotoCard";
import PhotoDetail from "../../components/PhotoDetail/PhotoDetail";
import { Modal } from 'antd';
import { PetsPictures } from '../../data/pets/pets';
import './pets.css';
import BackHomeIcon from "../../components/icons/BackHome/backhome";
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from "../../i18n";

function Pets() {
    const { t } = useTranslation();
    const [selectedPhoto, setSelectedPhoto] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        const idParam = searchParams.get('id');
        if (idParam) {
            const matchedPhoto = PetsPictures.find(
                (photo) => photo.id === Number(idParam)
            );
            if (matchedPhoto) {
                setSelectedPhoto(matchedPhoto);
            } else {
                setSelectedPhoto(null);
            }
        } else {
            setSelectedPhoto(null);
        }
    }, [searchParams]);

    const handlePhotoClick = (photo) => {
        setSelectedPhoto(photo);
        if (photo && photo.id) {
            const newParams = new URLSearchParams(searchParams);
            newParams.set('id', photo.id.toString());
            setSearchParams(newParams);
        }
    };

    const handleCancel = () => {
        setSelectedPhoto(null);
        const newParams = new URLSearchParams(searchParams);
        newParams.delete('id');
        setSearchParams(newParams);
    };

    return (
        <>
            <PageTitle>
                <Navigation></Navigation>
            </PageTitle>
            <BackHomeIcon></BackHomeIcon>
            <h1>{t("pages.portfolio.pets")}</h1>
            <h2>{t("pages.portfolio.clickToExplore")}</h2>

            <div className="photo-container">
                {PetsPictures.map((photo, index) => (
                    <div key={index} onClick={() => handlePhotoClick(photo)}>
                        <PhotoCard
                            src={photo.firstPic}
                            title={photo.title}
                            isPortrait={true}
                            index={index}
                        />
                    </div>
                ))}
            </div>

            <Modal
                open={selectedPhoto !== null}
                onCancel={handleCancel}
                footer={null}
                width={1000}
                className="photo-modal"
            >
                {selectedPhoto && (
                    <PhotoDetail
                        title={selectedPhoto.title}
                        description={selectedPhoto.description}
                        pics={selectedPhoto.pics}
                    />
                )}
            </Modal>

            <Footer></Footer>
        </>
    );
}

export default Pets